import { faCheckCircle, faClock, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

/**
 * Icono que representa el estado de una solicitud de validación.
 * Props:
 * - pendiente: Valor booleano.
 * - validado: Valor booleano.
 * - sufix: Sufijo de género y número (o, a, os, as).
 * Other props: See FontAwesomeIcon.
 */
export default function Validado(props) {
    const { pendiente, validado, sufix, className, ...otherProps } = props;
    const bsColor = pendiente ? "muted" : validado ? "success" : "danger";
    const title = pendiente ? "Pendiente" : validado ? `Aprobad${sufix}` : `Denegad${sufix}`;
    const icon = pendiente ? faClock : validado ? faCheckCircle : faTimesCircle;
    return (
        <FontAwesomeIcon
            icon={icon} title={title}
            className={`text-${bsColor} ${className}`}
            {...otherProps}
        />
    );
}

Validado.defaultProps = {
    sufix: "o"
}
